import dynamic from 'next/dynamic'

const SelectManagementSoftware = dynamic(() => import('./SelectManagementSoftware'));
const Beds24ApiKey = dynamic(() => import('./Beds24ApiKey'));
const Beds24Listings = dynamic(() => import('./Beds24Listings'));
const GuestyMarketplaceApiKey = dynamic(() => import('./GuestyMarketplaceApiKey'));
const RentalsUnitedLogin = dynamic(() => import('./RentalsUnitedLogin'));
const HostawayApiKey = dynamic(() => import('./HostawayApiKey'));
const SyncWait = dynamic(() => import('./SyncWait'));
const SelectRiskTolerance = dynamic(() => import('./SelectRiskTolerance'));
const ConfirmEmail = dynamic(() => import('./ConfirmEmail'));
const BasicInfo = dynamic(() => import('./BasicInfo'));
const CreatePassword = dynamic(() => import('./CreatePassword'));
const Billing = dynamic(() => import('./Billing'));
const UpdateConnection = dynamic(() => import('./UpdateConnection'));
const SmartBnbOauth = dynamic(() => import('./SmartBnbOauth'));
const InforHMS = dynamic(() => import('./InforHMS'));
const Impala = dynamic(() => import('./Impala'));
const Opera = dynamic(() => import('./Opera'));
const StreamlineApiKey = dynamic(() => import('./StreamlineApiKey'));
const LavandaApiKey = dynamic(() => import('./LavandaApiKey'));
const TrackApiKey = dynamic(() => import('./TrackApiKey'));
const StayntouchApiKey = dynamic(() => import('./StayntouchApiKey'));
const EscapiaPmcId = dynamic(() => import('./EscapiaPmcId'));



const screens = (props) => {

    return {
        guesty: {
            names: [
                'SelectManagementSoftware',
                'GuestyApiKeys',
                'SyncWait',
                'SelectRiskTolerance',
                'ConfirmEmail',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'GuestyApiKeys': GuestyMarketplaceApiKey,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'ConfirmEmail': ConfirmEmail,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'GuestyApiKeys': {
                    onSubmit: 'handleStartOnboarding',
                    swapScreen: 'handleSwapGuestyScreen',
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'ConfirmEmail': {
                    onSubmit: 'handleConfirmedEmail',
                    goBack: 'prevPage'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        guesty_update: {
            names: [
                'SelectManagementSoftware',
                'GuestyApiKeys',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'GuestyApiKeys': GuestyMarketplaceApiKey,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'GuestyApiKeys': {
                    onSubmit: 'nextPage',
                    swapScreen: 'handleSwapGuestyScreen',
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
        rentalsunited: {
            names: [
                'SelectManagementSoftware',
                'RentalsUnitedLogin',
                'SyncWait',
                'SelectRiskTolerance',
                'ConfirmEmail',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'RentalsUnitedLogin': RentalsUnitedLogin,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'ConfirmEmail': ConfirmEmail,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'RentalsUnitedLogin': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'ConfirmEmail': {
                    onSubmit: 'handleConfirmedEmail',
                    goBack: 'prevPage'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        hostaway: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'HostawayApiKey',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'HostawayApiKey': HostawayApiKey,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'nextPage'
                },
                'HostawayApiKey': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        stayntouch: {
            names: [
                'SelectManagementSoftware',
                'StayntouchApiKey',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'StayntouchApiKey': StayntouchApiKey,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'StayntouchApiKey': {
                    onSubmit: 'nextPage',
                },
                'BasicInfo': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        apaleo: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        apaleo_update: {
            names: [
                'SelectManagementSoftware',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
        cloudbeds: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        cloudbeds_update: {
            names: [
                'SelectManagementSoftware',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
        myvr: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        myvr_update: {
            names: [
                'SelectManagementSoftware',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
        smartbnb: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'SmartBnbOauth',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'SmartBnbOauth': SmartBnbOauth,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SmartBnbOauth': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        inforhms: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'InforHMS',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'InforHMS': InforHMS,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'nextPage'
                },
                'InforHMS': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        inforhms_update: {
            names: [
                'SelectManagementSoftware',
                'InforHMS',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'InforHMS': InforHMS,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'InforHMS': {
                    goBack: 'prevPage',
                    onSubmit: 'nextPage'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
        impala: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'Impala',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'Impala': Impala,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'nextPage'
                },
                'Impala': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        opera: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'Opera',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'Opera': Opera,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'nextPage'
                },
                'Opera': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        streamline: {
            names: [
                'SelectManagementSoftware',
                'StreamlineApiKey',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'StreamlineApiKey': StreamlineApiKey,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'StreamlineApiKey': {
                    onSubmit: 'nextPage',
                },
                'BasicInfo': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        trackhs: {
            names: [
                'SelectManagementSoftware',
                'TrackApiKey',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'TrackApiKey': TrackApiKey,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'TrackApiKey': {
                    onSubmit: 'nextPage',
                },
                'BasicInfo': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        escapia: {
            names: [
                'SelectManagementSoftware',
                'EscapiaPmcId',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'EscapiaPmcId': EscapiaPmcId,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'EscapiaPmcId': {
                    onSubmit: 'nextPage',
                },
                'BasicInfo': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        lavanda: {
            names: [
                'SelectManagementSoftware',
                'LavandaApiKey',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'LavandaApiKey': LavandaApiKey,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'LavandaApiKey': {
                    onSubmit: 'nextPage',
                },
                'BasicInfo': {
                    goBack: 'prevPage',
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        beds24: {
            names: [
                'SelectManagementSoftware',
                'Beds24ApiKey',
                'Beds24Listings',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'Beds24ApiKey': Beds24ApiKey,
                'Beds24Listings': Beds24Listings,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'Beds24ApiKey': {
                    onSubmit: 'nextPage'
                },
                'Beds24Listings': {
                    onSubmit: 'nextPage',
                    goBack: 'prevPage'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding',
                    goBack: 'prevPage'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        beds24_update: {
            names: [
                'SelectManagementSoftware',
                'Beds24ApiKey',
                'Beds24Listings',
                'UpdateConnection',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'Beds24ApiKey': Beds24ApiKey,
                'Beds24Listings': Beds24Listings,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'Beds24ApiKey': {
                    onSubmit: 'nextPage'
                },
                'Beds24Listings': {
                    onSubmit: 'nextPage',
                    goBack: 'prevPage'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                }
            }
        },
        booking: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        booking_update: {
            names: [
                'SelectManagementSoftware',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
        hostfully: {
            names: [
                'SelectManagementSoftware',
                'BasicInfo',
                'SyncWait',
                'SelectRiskTolerance',
                'CreatePassword',
                'Billing',
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'BasicInfo': BasicInfo,
                'SyncWait': SyncWait,
                'SelectRiskTolerance': SelectRiskTolerance,
                'CreatePassword': CreatePassword,
                'Billing': Billing,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'BasicInfo': {
                    onSubmit: 'handleStartOnboarding',
                    goBack: 'prevPage'
                },
                'SyncWait': {
                    onSubmit: 'nextPage'
                },
                'SelectRiskTolerance': {
                    onSubmit: 'handleSelectedRiskTolerance'
                },
                'CreatePassword': {
                    onSubmit: 'handleSaveUser',
                    goBack: 'prevPage'
                },
                'Billing': {
                    onSubmit: 'handleFinishOnboarding'
                }
            }
        },
        hostfully_update: {
            names: [
                'SelectManagementSoftware',
                'UpdateConnection'
            ],
            components: {
                'SelectManagementSoftware': SelectManagementSoftware,
                'UpdateConnection': UpdateConnection,
            },
            propsKeys: {
                'SelectManagementSoftware': {
                    onSubmit: 'handleSelectedSoftware'
                },
                'UpdateConnection': {
                    onSubmit: 'handleUpdateConnection',
                    goBack: 'prevPage'
                },
            }
        },
    }
}


const getScreen = (props) => {
    const {page, update, ctx} = props;
    let {pms} = props;
    const allScreens = screens(props);
    const screenStack = [];

    if (update && allScreens[`${pms}_update`]) {
        pms = `${pms}_update`
    }

    if (!allScreens[pms]) {
        return {}
    }

    // add available screens to stack list
    allScreens[pms].names.forEach(name => {
        screenStack.push(name)
    });

    // remove billing page for channel/partner account signups
    if (ctx && ctx.xd) {
        allScreens[pms].names = allScreens[pms].names.filter(name => name !== 'Billing');
        const lastScreen = allScreens[pms].names[allScreens[pms].names.length - 1];
        allScreens[pms].propsKeys[lastScreen].onSubmit = 'handleFinishOnboarding';
    }

    // remove password page for channel/partner account signups
    if (ctx && ctx.disablePasswordScreen) {
        allScreens[pms].names = allScreens[pms].names.filter(name => name !== 'CreatePassword');
        const lastScreen = allScreens[pms].names[allScreens[pms].names.length - 1];
        allScreens[pms].propsKeys[lastScreen].onSubmit = 'handleFinishOnboarding';
    }

    // meta data
    const isFinalPage = !!(!screenStack[page + 2]);
    const screenCount = screenStack.length;

    // return screen
    return {
        CurrentScreen: allScreens[pms].components[screenStack[page]],
        isFinalPage,
        screenCount,
        screenStack,
        propsKeys: allScreens[pms].propsKeys,
        screenName: screenStack[page],
    }
}

export {getScreen, screens}
export default getScreen